import { useCallback, useRef, useEffect, useState } from 'react';
import { AppState } from 'react-native';
import { openSettings } from 'react-native-permissions';
import { Camera } from 'utils/packages/Camera';
const useCameraPermission = () => {
    const [accessAllowed, setAccessAllowed] = useState();
    const skipPermissionCheck = useRef(false); // used on android only
    useEffect(() => {
        checkAccessToCamera();
        const appStateSubsription = AppState.addEventListener('change', (status) => {
            if (status === 'active') {
                checkAccessToCamera();
            }
        });
        return () => {
            appStateSubsription.remove();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const timeoutRef = useRef(undefined);
    const checkAccessToCamera = useCallback(async () => {
        try {
            const status = Camera.getCameraPermissionStatus();
            if (status === 'denied' || status === 'not-determined') {
                if (skipPermissionCheck.current) {
                    setAccessAllowed(false);
                    // otherwise we go to infinite loop:
                    // try to request permission -> app state background -> app state active -> try to request permission
                    // because if user denies, requestCameraPermission still does something that triggers app state changes
                    return;
                }
                skipPermissionCheck.current = true;
                const newStatus = await Camera.requestCameraPermission();
                setAccessAllowed(newStatus === 'granted');
                timeoutRef.current = setTimeout(() => {
                    skipPermissionCheck.current = false;
                }, 300);
            }
            else {
                setAccessAllowed(status === 'granted');
            }
        }
        catch {
            // I don’t think we can do anything meaningful here
        }
    }, []);
    useEffect(() => () => {
        clearTimeout(timeoutRef.current);
    }, []);
    const goToSettings = useCallback(() => {
        skipPermissionCheck.current = false;
        openSettings();
    }, []);
    return [accessAllowed, goToSettings];
};
export default useCameraPermission;
